import { ArrowUpRight, Sparkles } from 'lucide-react';

export default function FinalCta() {
  return (
    <section
      id="build"
      className="relative px-5 md:px-10 lg:px-14 py-24 md:py-32 border-t border-white/10 overflow-hidden"
      data-testid="final-cta-section"
    >
      <span
        className="pointer-events-none absolute -bottom-40 -left-40 w-[55vw] h-[55vw] rounded-full blur-3xl opacity-25"
        style={{ background: 'radial-gradient(closest-side, #FF3D2E, transparent 70%)' }}
      />
      <div className="relative">
        <p className="text-[10px] md:text-[11px] tracking-[0.3em] text-white/55 mb-6">
          — BUILD WITH SMG
        </p>
        <h2 className="font-display text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight text-white max-w-5xl">
          Let&apos;s build the next brand movement.
        </h2>
        <p className="mt-8 text-white/75 text-lg md:text-xl leading-relaxed max-w-3xl">
          Whether you are launching, repositioning, scaling, or building a co-branded partnership, SMG turns ideas into market-ready brand systems — engineered for culture and calibrated for revenue.
        </p>
        <div className="mt-12 flex flex-wrap items-center gap-4">
          <a
            href="#contact"
            className="group relative inline-flex items-center gap-3 px-7 py-5 bg-[#FF3D2E] text-white text-[11px] tracking-[0.25em] hover:bg-[#ff5446] transition-colors overflow-hidden"
            data-testid="final-cta-schedule-btn"
          >
            <Sparkles className="w-4 h-4 group-hover:rotate-12 transition-transform" />
            <span>SCHEDULE A STRATEGY CALL</span>
            <ArrowUpRight className="w-4 h-4 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-transform" />
          </a>
          <a
            href="#work"
            className="inline-flex items-center gap-2 px-7 py-5 border border-white/25 text-[11px] tracking-[0.25em] text-white hover:bg-white hover:text-black transition-colors"
            data-testid="final-cta-work-btn"
          >
            SEE THE WORK
          </a>
        </div>
      </div>
    </section>
  );
}
